import { api } from './authService';

const enrollmentService = {
  // Get all semesters for the current learner
  getSemesters: async () => {
    try {
      const response = await api.get('/enrollment/semesters');
      return response.data;
    } catch (error) {
      console.error('Error fetching semesters:', error);
      throw error;
    }
  },

  // Get subjects with filters
  getSubjects: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.year) params.append('year', filters.year);
      if (filters.track) params.append('track', filters.track);
      if (filters.q) params.append('q', filters.q);

      const url = `/enrollment/subjects?${params.toString()}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching subjects:', error);
      throw error;
    }
  },

  // Get current enrollments for a semester
  getEnrollments: async (semesterId) => {
    try {
      const response = await api.get(`/enrollments?semesterId=${semesterId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrollments:', error);
      throw error;
    }
  },

  // Update enrollments in bulk (replace semantics)
  updateEnrollmentsBulk: async (semesterId, subjectIds) => {
    try {
      const payload = {
        semesterId: Number(semesterId),
        subjectIds: subjectIds.map(id => Number(id))
      };
      const response = await api.post('/enrollments/bulk', payload);
      return response.data;
    } catch (error) {
      console.error('Error updating enrollments:', error);
      console.error('Response status:', error.response?.status);
      console.error('Response data:', error.response?.data);
      throw error;
    }
  },


};

export default enrollmentService;